export type State = {
	stage: string;
	subStage: string | null;
	sessionIdx?: number;
	processed?: boolean;
	archived?: boolean;
	playbackQueue: any[]; // Using any for now to avoid circular deps or complex imports, can refine later
	currentPlayback: any | null;
	playlist: string[];
	playlistIdx: number;
};

export interface setStatePayload {
	stage: string;
	subStage?: string;
	sessionIdx?: number;
}

export enum KioskActions {
	SET_KIOSK_STAGE = "Kiosk/SET_KIOSK_STAGE",
	PROXY_KIOSK_UPDATE = "Kiosk/PROXY_KIOSK_UPDATE",
	QUEUE_PLAYBACK = "Kiosk/QUEUE_PLAYBACK",
	DEQUEUE_PLAYBACK = "Kiosk/DEQUEUE_PLAYBACK",
	BATCH_QUEUE_PLAYBACKS = "Kiosk/BATCH_QUEUE_PLAYBACKS",
	UPDATE_PLAYLIST = "Kiosk/UPDATE_PLAYLIST",
	ADVANCE_PLAYLIST = "Kiosk/ADVANCE_PLAYLIST",
}
